<template>
  <div class="content starting">
    <div class="login boxLogin">
        <b-row>
            <b-col class="box" v-bind:style="{ backgroundImage: 'url(' + background + ')'}">
                <img :src="logo" v-bind:class="position">
            </b-col>
            <b-col>
        <h4>Delete user account</h4>
        <form @submit.prevent="submit">
            <div class="form-group" :class="{ 'form-group--error': $v.form.email.$error }">
                <input class="form-control" :placeholder="$t('messages.login.email')" v-model.trim="$v.form.email.$model" />
            </div>
            <div v-if="$v.form.$error">
                <div class="error" v-if="!$v.form.email.required">{{ $t('messages.login.error.required') }}</div>
                <div class="error" v-if="!$v.form.email.email">{{ $t('messages.login.error.mailNotValid') }}</div>
            </div>

             

                <div class="form-group" :class="{ 'form-group--error': $v.form.password.$error }">
                    <input class="form-control" :placeholder="$t('messages.login.password')" type="password" v-model.trim="$v.form.password.$model"/>
                </div>
                <div v-if="$v.form.$error">
                    <div class="error" v-if="!$v.form.password.required">{{ $t('messages.login.error.required') }}</div>
                </div>
            
                Please note that this action can't be undone. By confirming this action we will delete all your personal data from the system.
                <div class="form-group" :class="{ 'form-group--error': $v.form.terms.$error }" >
                       <b-form-checkbox class="form-control"
                        id="checkbox-1"
                        v-model="$v.form.terms.$model"
                        name="checkbox-1"
                        value=true
                        unchecked-value="false"
                        >
                        Confirm the deletion of my account
                        </b-form-checkbox>
                </div>
                <div v-if="$v.form.$error">
                    <div class="error" v-if="!$v.form.terms.sameAs"> You must confirm your account deletion action</div>
                </div>
                        
                <vue-recaptcha 
                    sitekey="6LccKH0UAAAAAFP2j4TmFl3UF5_j57eldq12H-or"
                    v-model="form.recaptcha"
                    @verify="onCapchaVerify"
                    style="margin-top:10px;overflow:hidden;"
                    >
                </vue-recaptcha>
                <div v-if="$v.form.$error && !form.recaptcha || form.recaptchaError">
                    <div class="error"> {{ $t('messages.login.error.required') }}</div>
                </div>
                <el-col>
                    <button type="submit" class="button" style="margin-top:15px">Delete account</button>
                </el-col>
                <el-col>
                    <!-- <b-button class="remember" size="sm" variant="link" v-on:click="callLogin"> {{ $t("messages.login.backToLogin") }} </b-button> -->
                <router-link class="remember" :to="`/login`">
                    {{ $t("messages.login.backToLogin") }}
                </router-link>
                </el-col>
        </form>
        </b-col>
        </b-row>
    </div>
    </div>
</template>

<script>
const fb = require('../firebaseConfig.js')
import {required,email, sameAs, minLength} from 'vuelidate/lib/validators';
import VueRecaptcha from 'vue-recaptcha';
import { mapState } from 'vuex'

export default {
    name: 'signUp',
    components: {
        VueRecaptcha,
    },
    props: {
        actionCodeSettings: {},
    },
    beforeCreate(){
      let host = window.location.host.toLowerCase()
      switch(host){
        case 'www.da-gen.com':
        case 'da-gen.com':
            this.logo = null
            this.background = require('@/assets/logos/bg/da-gen.jpg')
            this.position='middle',
            this.company = 4;
            this.isHW = true
        break;
        case 'hayward.vistapool.es':
        case 'poolwatch.hayward.fr':
            this.logo = null 
            this.background = require('@/assets/logos/bg/PHOTO-HAYWARD-A4.png')
            this.position='top',
            this.company = 2
            this.isHW = true
        break;
        case 'www.kripsolpool.com':
        case 'kripsolpool.com':
            this.logo = null 
            this.background = require('@/assets/logos/bg/PHOTO-KRIPSOL-A4-1.png')
            this.position='top',
            this.company = 5
            this.isHW = true
        break;
        case 'naturally-salt-poolaccess.de':
        case 'naturally-salt-poolaccess.eu':
        case 'naturally-salt-poolaccess.at':
        case 'naturally-salt-poolaccess.fr':
        case 'naturally-salt-poolaccess.es':
        case 'naturally-salt-poolaccess.com':
        case 'naturally-salt-poolaccess.net':
        case 'www.naturally-salt-poolaccess.de':
        case 'www.naturally-salt-poolaccess.eu':
        case 'www.naturally-salt-poolaccess.at':
        case 'www.naturally-salt-poolaccess.fr':
        case 'www.naturally-salt-poolaccess.es':
        case 'www.naturally-salt-poolaccess.com':
        case 'www.naturally-salt-poolaccess.net':
            this.logo = require('@/assets/logos/naturally.png') 
            this.background = require('@/assets/logos/bg/bg_naturally_salt.jpg')
            this.position='middle'
            this.company = 3
            this.isHW = false
        break;
        case 'app.brilix.com':
            this.logo = require('@/assets/logos/brilix_home.png') 
            this.background = require('@/assets/logos/bg/brilix.jpg')
            this.position='top'
            this.company = 6
            this.isHW = false
            this.title = 'Brilix'
        break;
        case 'compass-salt-water.com':
            this.logo =  require('@/assets/logos/compass.png') 
            this.background = require('@/assets/logos/bg/compass.jpg')
            this.position='top'
            this.company = 7
            this.isHW = false
        break;
        
        default:
            this.logo = require('@/assets/logos/logo.png')
            this.background = require('@/assets/logos/bg/pool_footage.jpg')
            this.position='middle',
            this.company = 1
            this.isHW = true
      }

    },

    computed: {
        ...mapState(['languages'])
    }, 
    watch: {
      "$i18n.locale": function(oldV, newV) {
      }
    },
    data: function () {
        return {
            company:"",
            form: {
                name: "",
                email: "",
                terms:"",
                recaptcha:"",
                recaptchaError: false,
                accept: false
            },
        }
    },
    validations: {
        form: {
            terms: {
                sameAs: sameAs( () => 'true' ),
            },
            email: {
                required,
                email
            },
            password: {
                required,
            },
        }
    },
    methods: {
        callLogin: function () {
            this.$emit('setLogin');
        },
        onCapchaVerify: function (response) {
            this.form.recaptcha = true;
            this.form.recaptchaError= false;
        },
        submit() {
            this.$v.form.$touch();
            if (this.$v.form.$error | !this.form.recaptcha){
                this.form.recaptchaError = true;
                return
            }
            this.setLogin();
        },
       
        setLogin: function () {
            this.$snotify.async(this.$t("messages.login.verifyUser"), () => new Promise((resolve, reject) => {
                fb.auth.signInWithEmailAndPassword(this.form.email, this.form.password).then((current) => {
                    if(current){
                       fb.auth.currentUser.delete().then( (deleted) => {
                            this.signOut();
                            resolve({
                            body: "Your user has been deleted correctly",
                            config: {
                                timeout: 3500,
                                closeOnClick: true
                            }
                            })
                        })
                    }
                }).catch( (err) => {
                    reject({
                        body: this.$t("messages.userNotExists"),
                        config: {
                            timeout: 2000,
                            closeOnClick: true
                        }
                    })
                })
            }))
        },

        signOut(){
            fb.auth.signOut().then(() => {
            this.$store.dispatch('clearData');
            this.form.email = "";
            this.form.password = "";
            this.form.terms = false;
        }).catch(err => {
            console.log(err)
        })
        },
        showTerms() {
            this.$emit('onShowTerms')
        }
    }
}
</script>

<style>
.modal-detail {
    border-radius: 5px;
    background: #F7F7F7;
    box-shadow: 5px 5px 30px 0px rgba(46,61,73, 0.6);
  }

  .modal-detail-content {
    padding: 10px;
  
  }

</style>


// WEBPACK FOOTER //
// src/components/UserUnsubscribe.vue